<google-pay-button
  [environment]="googlePayEnvironment"
  [buttonType]="buttonType"
  [buttonLocale]="buttonLanguage"
  [buttonRadius]="100"
  buttonSizeMode="fill"
  buttonColor="black"
  [paymentRequest]="
    buildPaymentRequest({
      totalPriceStatus: 'FINAL',
      totalPrice: pricingInformation.total.toString(),
      totalPriceLabel:
        (debitDate === null
          ? 'checkout.paymentWallet.googlePayButton.flyOutTotalLabel'
          : 'checkout.paymentWallet.googlePayButton.flyOutTotalLabelDelayedPayment'
        ) | transloco: { vendorName: this.vendorName, debitDate: this.debitDate ? (this.debitDate | translocoDate) : '' },
      displayItems: (this.displayItems$ | async) ?? [],
      currencyCode: pricingInformation.currency,
      countryCode: pricingInformation.userCountryISO2Lookup ?? undefined
    })
  "
  (readytopaychange)="onReadyToPayChange($event)"
  (loadpaymentdata)="onLoadPaymentData($event)"
  (errorCallback)="onError($event)"></google-pay-button>
